<template>
  <div>
    <b-collapse class="card is-bg-transparent is-no-box-shadow" aria-id="contentIdForA11y3">
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header is-no-box-shadow"
        role="button"
        aria-controls="contentIdForA11y3">
        <p class="card-header-title has-text-dark">
          <i class="fas fa-users fa-lg"></i>&nbsp;&nbsp;&nbsp;Kelas Umum
        </p>
      </div>
      <div class="card-table is-boxed">
        <div class="">
          <table class="table is-fullwidth">
            <tbody v-if="!isEmpty(followed_groups)">
              <tr v-for="group in followed_groups" :key="group.id">
                <td style="padding: 7px;">
                  <div class="columns is-mobile is-vcentered">
                    <div class="column is-narrow">
                      <shorticon style="margin: 0;" :shortName="group.shortName" size="small" :bgColor="group.color"></shorticon>
                    </div>
                    <div class="column">
                      <p class="title is-6 tooltip font-14" :data-tooltip="group.name">
                        <strong style="font-weight: bold;">
                          <nuxt-link class="has-text-primary" :to="{path: `/panel/groups/${group.id}`}">{{ group.name }}</nuxt-link>
                        </strong>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="columns is-mobile is-vcentered">
                    <div class="column has-text-centered">
                      <nuxt-link :to="{path: '/panel/groups'}"><small class="has-text-info">Lihat Semua</small></nuxt-link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="isEmpty(followed_groups) && !loading_followed">
              <tr><td><p class="has-text-grey font-14">Data tidak ditemukan.</p></td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <spinner-loading v-if="loading_followed"></spinner-loading>

      <footer class="card-footer" v-if="dataProviderFollowed.total <= 0 || loading_followed">
        <div class="card-footer-item">
          <pagination :dataProvider="dataProviderFollowed" :clickHandler="getFollowedGroups"></pagination>
        </div>
      </footer>
    </b-collapse>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GROUP } from '~/consts';

export default {
  mounted() {
    this.getFollowedGroups();
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
    }),
  },

  data() {
    return {
      loading_followed: false,
      followed_groups: [],
      dataProviderFollowed: {
        criterion: [],
        page: {
          count: 0,
          current: 1,
          limit: 3,
          next: 0,
          previous: 0,
          total: 0
        },
        sort: [
          { criteria: 'latest_post', order: 'desc', no_table: true }
        ]
      },
    }
  },

  methods: {
    getFollowedGroups(refresh = false) {
      const vm = this;
      vm.loading_followed = true;

      if (refresh) {
          vm.dataProviderFollowed.page['current'] = 1;
        }

      this.$axios.post(GROUP.GET_OWNED, {
        role: ['O', 'A', 'M'],
        dataProvider: JSON.stringify(vm.dataProviderFollowed)
      })
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          if (refresh) {
            vm.followed_groups = data.data.data;
          } else {
            let followed_group_ids = collect(vm.followed_groups).pluck('id').toArray();
            let followed_groups = collect(data.data.data).filter((g) => {
              if (followed_group_ids.indexOf(g.id) > -1) {
                return false;
              }

              return true;
            }).toArray();
            vm.followed_groups = vm.followed_groups.concat(followed_groups);
          }

          vm.dataProviderFollowed = data.data.dataProvider;
        }

        vm.loading_followed = false;
      }).catch(() => {
        vm.loading_followed = false;
      });
    },
  }
}
</script>
